"use client";

import { ReactNode } from "react";
import { UStyles } from "@/app/utils/UStyles";
import styles from "./ScriptStep.module.css";

type Props = {
  index: number;
  isLast: boolean;
  isSplit: boolean;
  children: ReactNode;
};

export default function ScriptStep(props: Props) {
  const { index, isLast, isSplit, children } = props;

  return (
    <div className={styles.step}>
      <div className={styles.timeline}>
        <span className={styles.marker}>{index + 1}</span>
        {!isLast && <span className={styles.line} />}
      </div>

      <div className={UStyles.classNames(styles.body, isSplit && styles.bodySplit)}>{children}</div>
    </div>
  );
}
